import { Avatar, Box, Typography, useTheme } from "@mui/material";
import profileInfoStyles from "./profileInfoStyles";

const ProfileInfo = ({ username, email }) => {
  const theme = useTheme();
  const styles = profileInfoStyles(theme);

  return (
    <Box sx={styles.container}>
      <Avatar sx={styles.avatar}>{username?.[0]?.toUpperCase()}</Avatar>

      <Typography sx={styles.username}>{username}</Typography>

      <Typography sx={styles.email}>{email}</Typography>
    </Box>
  );
};

export default ProfileInfo;
